/* eslint-disable eqeqeq */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable array-callback-return */
/* eslint-disable no-unused-vars */
/* eslint-disable no-redeclare */
/* eslint-disable react/no-direct-mutation-state */
/* eslint-disable no-use-before-define */

import 'bootstrap/dist/css/bootstrap.min.css';
import React from 'react';
import { useContext } from 'react';
import LoaderContext from '../../../components/loaderContext';


class Loading extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isShow: this.props.triggerLoader ?? false
        };

        this.triggerLoading = this.triggerLoading.bind(this);
    }
    componentDidMount() {

    }

    triggerLoading(bool) {
        this.setState({ isShow: bool });
    }

    render() {
        // console.log("this.state.IsShow", this.state.isShow)
        // var isshow = this.state.IsShow;
        return (
            this.state.isShow && <div className="position-fixed w-100 h-100" style={{ top: 0, left: 0, zIndex: 999 }}>
                <div className="w-100 h-100 d-flex justify-content-center align-items-center" style={{ backgroundColor: 'rgba(192,192,192,0.2)' }}>
                    <Loader />
                </div>
            </div>
            // this.state.IsShow && <div className="position-fixed w-100 h-100" style={{ top: 0, left: 0, zIndex: 999 }}>
            //     <div className="w-100 h-100 d-flex justify-content-center align-items-center" style={{ backgroundColor: 'rgba(192,192,192,0.2)' }}>
            //         <img alt="loading" src="./images/loading.gif" className="icon-loading" />
            //     </div>
            // </div>
        );
    }
}
function Loader(props) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            style={{ margin: "auto", background: "none" }}
            width="90"
            height="90"
            display="block"
            preserveAspectRatio="xMidYMid"
            viewBox="0 0 100 100"
            {...props}
        >
            <rect width="8" height="15" x="46" y="23.5" rx="4" ry="4.05">
                <animate
                    attributeName="opacity"
                    begin="-0.7346189164370982s"
                    dur="0.8264462809917356s"
                    keyTimes="0;1"
                    repeatCount="indefinite"
                    values="1;0"
                ></animate>
            </rect>
            <rect
                width="8"
                height="15"
                x="46"
                y="23.5"
                rx="4"
                ry="4.05"
                transform="rotate(40 50 50)"
            >
                <animate
                    attributeName="opacity"
                    begin="-0.642791551882461s"
                    dur="0.8264462809917356s"
                    keyTimes="0;1"
                    repeatCount="indefinite"
                    values="1;0"
                ></animate>
            </rect>
            <rect
                width="8"
                height="15"
                x="46"
                y="23.5"
                rx="4"
                ry="4.05"
                transform="rotate(80 50 50)"
            >
                <animate
                    attributeName="opacity"
                    begin="-0.5509641873278237s"
                    dur="0.8264462809917356s"
                    keyTimes="0;1"
                    repeatCount="indefinite"
                    values="1;0"
                ></animate>
            </rect>
            <rect
                width="8"
                height="15"
                x="46"
                y="23.5"
                rx="4"
                ry="4.05"
                transform="rotate(120 50 50)"
            >
                <animate
                    attributeName="opacity"
                    begin="-0.4591368227731864s"
                    dur="0.8264462809917356s"
                    keyTimes="0;1"
                    repeatCount="indefinite"
                    values="1;0"
                ></animate>
            </rect>
            <rect
                width="8"
                height="15"
                x="46"
                y="23.5"
                rx="4"
                ry="4.05"
                transform="rotate(160 50 50)"
            >
                <animate
                    attributeName="opacity"
                    begin="-0.3673094582185491s"
                    dur="0.8264462809917356s"
                    keyTimes="0;1"
                    repeatCount="indefinite"
                    values="1;0"
                ></animate>
            </rect>
            <rect
                width="8"
                height="15"
                x="46"
                y="23.5"
                rx="4"
                ry="4.05"
                transform="rotate(200 50 50)"
            >
                <animate
                    attributeName="opacity"
                    begin="-0.27548209366391185s"
                    dur="0.8264462809917356s"
                    keyTimes="0;1"
                    repeatCount="indefinite"
                    values="1;0"
                ></animate>
            </rect>
            <rect
                width="8"
                height="15"
                x="46"
                y="23.5"
                rx="4"
                ry="4.05"
                transform="rotate(240 50 50)"
            >
                <animate
                    attributeName="opacity"
                    begin="-0.18365472910927455s"
                    dur="0.8264462809917356s"
                    keyTimes="0;1"
                    repeatCount="indefinite"
                    values="1;0"
                ></animate>
            </rect>
            <rect
                width="8"
                height="15"
                x="46"
                y="23.5"
                rx="4"
                ry="4.05"
                transform="rotate(280 50 50)"
            >
                <animate
                    attributeName="opacity"
                    begin="-0.09182736455463728s"
                    dur="0.8264462809917356s"
                    keyTimes="0;1"
                    repeatCount="indefinite"
                    values="1;0"
                ></animate>
            </rect>
            <rect
                width="8"
                height="15"
                x="46"
                y="23.5"
                rx="4"
                ry="4.05"
                transform="rotate(320 50 50)"
            >
                <animate
                    attributeName="opacity"
                    begin="0s"
                    dur="0.8264462809917356s"
                    keyTimes="0;1"
                    repeatCount="indefinite"
                    values="1;0"
                ></animate>
            </rect>
        </svg>
    );
}

export const LoaderWithProps = () => {
    const loader = useContext(LoaderContext);
    // console.log("loader",loader)
    return (<>
        {loader.triggerLoader && <div className="position-fixed w-100 h-100" style={{ top: 0, left: 0, zIndex: 10000 }}>
            <div className="w-100 h-100 d-flex justify-content-center align-items-center" style={{ backgroundColor: 'rgba(192,192,192,0.2)' }}>
                <Loader />
            </div>
        </div>}
    </>);
}
export { Loader };
export default Loading;

